import React from 'react';
import useSetExport from '@components/export/useSetExport';
import { useSelector } from 'react-redux';
import { isMetricFilterAppliedSelector } from '@store/trends/base/selectors';
import { getMetricFilterMetric, getMetricFilterPctMetric } from '../dimension-table/utils';
import { chartIntervalSelector } from '@store/trends/birdChart/selectors';
import { buildIntervalText } from '@components/export/parsers';
import { MF_LABEL } from '@components/metrics-panel-hz/utils/metricFilterUtils';

function useSetErrorDimensionExport({ dimension, errorCodeInfo, data = [], totals = {} }) {

  const isMetricFilterApplied = useSelector(isMetricFilterAppliedSelector);
  const interval = useSelector(chartIntervalSelector);

  const headers: any = [{
    key: 'name',
    title: '',
    type: 'dimension',
  }];

  const { primary: metric, columnName, pctMetricKey: pctMetric } = errorCodeInfo;

  // base metric
  headers.push({ key: metric, title: columnName });

  // metric filter metric
  if (isMetricFilterApplied) {
    headers.push({ key: getMetricFilterMetric(metric), title: `[${MF_LABEL}] ` + columnName });
  }

  // percentage metric
  if (metric !== pctMetric) {
    headers.push({ key: pctMetric, title: columnName + ' (%)' });

    // percentage metric filter metric
    if (isMetricFilterApplied) {
      headers.push({ key: getMetricFilterMetric(pctMetric), title: `[${MF_LABEL}] ` + columnName + ' (%)' });
    }
  }

  // MF relative % metric
  if (isMetricFilterApplied) {
    headers.push({ key: getMetricFilterPctMetric(metric), title: `[${MF_LABEL}%] ` + columnName + ' (%)' });
  }


  useSetExport({
    pageKey: 'trends',
    sectionKey: 'dimensions-panel',
    widgetKey: `dimension-table-${dimension}`,
    headers,
    data: [totals].concat(data),
    widgetInfo: {
      title: `Dimension: Error Code (${buildIntervalText(interval)})`
    }
  });
}

export default useSetErrorDimensionExport;
